import no from "./no.json";
import en from "./en.json";

export const localeMessages = {
  no: no,
  en: en,
};
